let activeRequests = 0;
export const apiProgressBus = new EventTarget();

export function startRequest(): void {
  activeRequests++;
  apiProgressBus.dispatchEvent(new Event('change'));
}

export function endRequest(): void {
  activeRequests = Math.max(0, activeRequests - 1);
  apiProgressBus.dispatchEvent(new Event('change'));
}

export function isLoading(): boolean {
  return activeRequests > 0;
}

// Global API error bus — emits 'api-error' events for non-401 failures
// Components can listen to show a global snackbar instead of each handling independently
export const apiErrorBus = new EventTarget();

export interface ApiErrorDetail {
  message: string;
  status?: number;
}

export function emitApiError(detail: ApiErrorDetail): void {
  apiErrorBus.dispatchEvent(new CustomEvent<ApiErrorDetail>('api-error', { detail }));
}
